const LIST_USERS_REQUEST = 'users/LIST_USERS_REQUEST';
const LIST_USERS_FAILURE = 'users/LIST_USERS_FAILURE';
const LIST_USERS_SUCCESS = 'users/LIST_USERS_SUCCESS';

const LIST_ROLES_REQUEST = 'users/LIST_ROLES_REQUEST';
const LIST_ROLES_FAILURE = 'users/LIST_ROLES_FAILURE';
const LIST_ROLES_SUCCESS = 'users/LIST_ROLES_SUCCESS';

const CREATE_USER_REQUEST = 'users/CREATE_USER_REQUEST';
const CREATE_USER_FAILURE = 'users/CREATE_USER_FAILURE';
const CREATE_USER_SUCCESS = 'users/CREATE_USER_SUCCESS';

const UPDATE_MY_ACCOUNT_REQUEST = 'users/UPDATE_MY_ACCOUNT_REQUEST';
const UPDATE_MY_ACCOUNT_FAILURE = 'users/UPDATE_MY_ACCOUNT_FAILURE';
const UPDATE_MY_ACCOUNT_SUCCESS = 'users/UPDATE_MY_ACCOUNT_SUCCESS';

const REMOVE_USER_REQUEST = 'users/REMOVE_USER_REQUEST';
const REMOVE_USER_FAILURE = 'users/REMOVE_USER_FAILURE';
const REMOVE_USER_SUCCESS = 'users/REMOVE_USER_SUCCESS';

export default {
  LIST_USERS_REQUEST,
  LIST_USERS_FAILURE,
  LIST_USERS_SUCCESS,

  LIST_ROLES_REQUEST,
  LIST_ROLES_FAILURE,
  LIST_ROLES_SUCCESS,

  CREATE_USER_REQUEST,
  CREATE_USER_FAILURE,
  CREATE_USER_SUCCESS,

  UPDATE_MY_ACCOUNT_REQUEST,
  UPDATE_MY_ACCOUNT_FAILURE,
  UPDATE_MY_ACCOUNT_SUCCESS,

  REMOVE_USER_REQUEST,
  REMOVE_USER_FAILURE,
  REMOVE_USER_SUCCESS,
};
